import React, { useContext, useState, useEffect } from "react";

import { CoreContext } from "context/CoreContext";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, FormGroup, FormControlLabel, Checkbox, Typography, Link } from "@mui/material";
import { GoogleDocsViewer } from "components/Viewer";

export default function ModalScript() {
  const { modal, setModal, acceptAllCookies, rejectAllCookies, savePreferencesCookies, cookies } = useContext(CoreContext);
  const [preferences, setPreferences] = useState({
    essential: true,
    analytics: false,
    marketing: false,
  });
  const [termsAreOpen, setTermsAreOpen] = useState(false);

  const close = (event, reason) => {
    if (reason !== "backdropClick") {
      setModal(null);
    }
  };

  useEffect(() => {
    if (cookies) {
      setPreferences(cookies)
    }
  }, [])

  return (
    <Dialog
      open={modal}
      onClose={close}
      maxWidth={termsAreOpen ? "md" : "sm"}
      fullWidth
      sx={{ "& .MuiPaper-root": { borderRadius: "20px", padding: "20px" } }}
    >
      <DialogTitle>Gerenciar Cookies</DialogTitle>
      {!termsAreOpen ?
        <>
          <DialogContent>
            <Typography>
              Utilizamos cookies para melhorar sua experiência. Para mais informações, veja nossa{" "}
              <Link sx={{ cursor: "pointer" }} onClick={() => setTermsAreOpen(true)}>Política de Privacidade</Link>.
            </Typography>

            <FormGroup>
              <FormControlLabel control={<Checkbox checked disabled />} label="Essenciais (Sempre Ativos)" />
              <FormControlLabel
                control={<Checkbox checked={preferences.analytics} onChange={() => setPreferences(p => ({ ...p, analytics: !p.analytics }))} />}
                label="Cookies Analíticos"
              />
              <FormControlLabel
                control={<Checkbox checked={preferences.marketing} onChange={() => setPreferences(p => ({ ...p, marketing: !p.marketing }))} />}
                label="Cookies de Marketing"
              />
            </FormGroup>
          </DialogContent>
          <DialogActions>
            <Button onClick={rejectAllCookies} color="secondary">Recusar Todos</Button>
            <Button onClick={() => savePreferencesCookies(preferences)} color="primary">Salvar Preferências</Button>
            <Button onClick={acceptAllCookies} variant="contained" color="primary" sx={{ borderRadius: "50px" }}>Aceitar Todos</Button>
          </DialogActions>
        </>
        :
        <>
          <DialogContent
            sx={{ height: "55vh", padding: "0px", overflow: "hidden" }}
          >
            <GoogleDocsViewer docUrl="2PACX-1vQ6i2ME1MUsrGTUVdLspz64rZAkKPjAuuRrG2hoL3BBgepuJ10hNnqu1ZA-5IcPQg" />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setTermsAreOpen(false)} color="primary">Voltar</Button>
          </DialogActions>
        </>
      }
    </Dialog>
  );
}
